import React from "react"

import UmbraLogo from "./../../../UI/topMenu/logoUmbra.svg"
import fullscreen from "./../../../UI/topMenu/fullscreen.svg"

/*eslint-disable*/

interface Props {
    colorsData: any
}

interface State {
    isOptionsOpened: boolean,
    isHover: boolean,
    isFullScreen: boolean
}

class OptionsMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            isOptionsOpened: false,
            isHover: false,
            isFullScreen: false
        }
    }


    handleFullscreen = () => {
        this.setState({
            isFullScreen: !this.state.isFullScreen
        }, () => {
            if(this.state.isFullScreen){
                if(document.documentElement.requestFullscreen){
                    document.documentElement.requestFullscreen()
                }
            }
            else{
                document.exitFullscreen()
            }
        })
    }

    render(): React.ReactNode {
        return(
            <React.Fragment>
                {
                    this.props.colorsData ? 
                    <div 
                        className="options-btn"
                        style={{
                            backgroundColor: this.state.isOptionsOpened ? this.props.colorsData.main_buttons: "",
                            color: this.state.isOptionsOpened ? this.props.colorsData.secondary_text:this.props.colorsData.main_text,
                            transition: "all 0.2s ease-in-out"
                        }}
                        onClick = {() => {this.setState({isOptionsOpened: !this.state.isOptionsOpened})}}
                    >
                        ···
                    </div>:null
                }
                {
                    this.props.colorsData ?
                    <div className={this.state.isOptionsOpened ? "options-container fade-in":"options-container fade-out"}>
                        {
                            !(navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) ?
                            <React.Fragment>
                                <div 
                                    className="fullscreen-container"
                                    onMouseEnter={() => {this.setState({isHover: true})}} 
                                    onMouseLeave={() => {this.setState({isHover: false})}}
                                    onClick = {() => {this.handleFullscreen()}}
                                    style = {{
                                        backgroundColor: this.state.isFullScreen ? this.props.colorsData.main_buttons : this.state.isHover ? this.props.colorsData.secondary_buttons : "",
                                        transition: "all 0.2s ease-in-out"
                                    }}
                                >
                                    <img src={fullscreen} alt=""></img>
                                    <div 
                                        className="fullscreen-text" 
                                        style = {{
                                            color: this.state.isFullScreen ? this.props.colorsData.secondary_text : this.props.colorsData.main_text,
                                            transition: "all 0.2s ease-in-out"
                                        }}
                                    >
                                        Fullscreen
                                    </div>
                                </div>
                                <hr className="hr-options"></hr>
                            </React.Fragment>:null 
                        }
                        <div className="umbra-container">
                            <div className="umbra-powered-text">
                                Powered by
                            </div>
                            <a href='https://umbra3d.studio/' target="_blank" rel='noreferrer'>
                            <img src={UmbraLogo} alt=""></img>
                            </a>
                        </div>
                    </div>:null
                }
            </React.Fragment>
            
        )
    }
}

export default OptionsMobile